export default __webpack_public_path__ + "assets/schick_banner_740x120-875c7269bf8077c5f798c26b2e70cb02.jpg";